import * as moment from "moment";
import * as PlatypusCustomGraphs from '../components/Graphs/Platypus';
import * as PlatypusFooter from '../components/Page/Footer/FooterPlatypus';
import { DashboardContainerProps } from '../containers/dashboard.container';
import { activateAccountMapQueryStringToProps, changePasswordMapQueryStringToProps, siteDetailEventMapQueryStringToProps, siteDetailMapQueryStringToProps, siteDetailShouldRerouteHome } from '../helpers/configurationHelper';
import { Aggregate, Datum, ICustomConfiguration } from './ICustomConfiguration';

const GetSeasonName: any = (date: any) => {
    /* Find start of previous season */
    let Summer = 12;
    let Autumn = 3;
    let Winter = 6;
    let Spring = 9;

    let day = parseInt(date.format("D"));
    let month = parseInt(date.format("M"));
    let year = parseInt(date.format("YYYY"));

    if (day == 1) // first day of month - go to previous month
    {
        month--;
    }
    if (month < Autumn) {
        year--;
        month = Summer; // First 2 months need to be reset to summer
    }

    if (month < Winter) {
        return "Autumn";
    } else if (month < Spring) {
        return "Winter";
    } else if (month < Summer) {
        return "Spring";
    } else {
        return "Summer";
    }
}

const GetSeasonalQuarterDate: any = (date: any) => {
    /* Find start of previous season */
    let Summer = 12;
    let Autumn = 3;
    let Winter = 6;
    let Spring = 9;

    let day = parseInt(date.format("D"));
    let month = parseInt(date.format("M"));
    let year = parseInt(date.format("YYYY"));

    if (day == 1) // first day of month - go to previous month
    {
        month--;
    }
    if (month < Autumn) {
        year--;
        month = Summer; // First 2 months need to be reset to summer
    }

    let seasonMonth = 0;
    if (month < Winter) {
        // Current season is Autumn but we want previous season 
        seasonMonth = Autumn;

    } else if (month < Spring) {
        // Current season is Winter but we want previous season 
        seasonMonth = Winter;

    } else if (month < Summer) {
        // Current season is Spring but we want previous season 
        seasonMonth = Spring;

    } else {
        seasonMonth = Summer;
    }
    date = moment(`${year}-${seasonMonth}-1`);
    return date;
}

export const CustomConfiguration: ICustomConfiguration = {
    productName: "platypus",

    // component mappings
    MapMarker: undefined,// PlatypusMapMarker.default,
    CustomGraphs: PlatypusCustomGraphs.default,
    ContentPage: undefined,
    PageFooter: PlatypusFooter.default,

    enableBrowserGeolocation: false,
    defaultMapTypeId: 'roadmap',

    // host mappings
    googleApi: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAWpqvFDJ_faZ_OYjsGicI0_epY-NsLfDY&libraries=geometry,places,visualization',
    markerHost: process.env.NODE_ENV !== "production" ? "http://localhost:62113" : "http://platypusscan.newtongreen.com",

    // constants
    defaultPageTitle: "Australian Platypus Monitoring Network",
    defaultMapLatitude: -25,
    defaultMapLongitude: 134,
    defaultRoute: "/platypus/content",
    defaultTab: "CONTENT",

    pageTitleAppend: undefined, //" | Australian Platypus Conservancy",
    footerLogo: require("../assets/img/platypus/p-logo.png"),

    // localisation
    noSummaryData: "No data returned for the selected filter. Increase the Date Period",
    pleaseWait: "please wait, loading data",

    tabs: [
        {
            type: "CONTENT",
            route: "content",
            showSideBar: false,
            showContentHeader: false,
            showFooter: true,
            showHeader: false,
            bannerName: undefined,
            pageTitle: undefined,
            sidebarLink: {
                label: "Home",
                icon: "fa-home",
                hiddenOnTabs: [],
                hiddenWhenUnauthenticated: false
            },
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "MAP",
            route: "map",
            bannerName: undefined,
            pageTitle: undefined,
            mapTabSettings: {
                mapTypeId: 'roadmap',
                mapEnablePlotCreation: false,
                showAddPlotEventButton: false,
                showMapOptions: false
            },
            showSideBar: true,
            showContentHeader: false,
            showFooter: false,
            showHeader: true,
            sidebarLink: {
                label: "Findings",
                icon: "fa-map",
                hiddenOnTabs: [],
                hiddenWhenUnauthenticated: false
            },
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "SITE",
            route: "my-data",
            bannerName: undefined,
            pageTitle: undefined,
            showSideBar: true,
            showContentHeader: false,
            showFooter: false,
            showHeader: true,
            dataTabSettings: {
                limitToUserData: true
            },
            sidebarLink: {
                label: "My Data",
                icon: "fa-columns",
                hiddenOnTabs: [],
                hiddenWhenUnauthenticated: true
            },
            needsAuthentication: true,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "SITE_SELECT",
            route: "site-select",
            bannerName: undefined,
            pageTitle: undefined,
            mapTabSettings: {
                mapTypeId: 'satellite',
                mapEnablePlotCreation: true,
                showAddPlotEventButton: false,
                showMapOptions: false
            },
            showSideBar: true,
            showContentHeader: false,
            showFooter: false,
            showHeader: true,
            sidebarLink: {
                label: "Site Selection",
                icon: "fa-map-marker",
                hiddenOnTabs: [],
                hiddenWhenUnauthenticated: true
            },
            needsAuthentication: true,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "USER_PROFILE",
            route: "user",
            bannerName: undefined,
            pageTitle: undefined,
            showSideBar: true,
            showContentHeader: false,
            showFooter: false,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "WELCOME",
            route: "welcome",
            bannerName: undefined,
            pageTitle: undefined,
            showSideBar: true,
            showContentHeader: false,
            showFooter: false,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: true,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "PASSWORD_RESET",
            route: "passwordreset",
            bannerName: undefined,
            pageTitle: undefined,
            showSideBar: true,
            showContentHeader: false,
            showFooter: true,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: changePasswordMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "ACTIVATE_ACCOUNT",
            route: "activateaccount",
            bannerName: undefined,
            pageTitle: undefined,
            showSideBar: true,
            showContentHeader: false,
            showFooter: true,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: activateAccountMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "SITE_DETAIL",
            route: "site",
            bannerName: undefined,
            pageTitle: "View Site",
            showSideBar: true,
            showContentHeader: false,
            showFooter: false,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: siteDetailMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined;
            },
            shouldRerouteHome: siteDetailShouldRerouteHome
        },
        {
            type: "SURVEY",
            route: "add-data",
            dataTabSettings: {
                limitToUserData: true
            },
            showSideBar: true,
            showContentHeader: false,
            showFooter: false,
            showHeader: true,
            bannerName: undefined,
            pageTitle: undefined,
            sidebarLink: {
                label: "Add Data",
                icon: "fa-plus-square",
                hiddenOnTabs: undefined,
                hiddenWhenUnauthenticated: true
            },
            needsAuthentication: true,
            mapQueryStringToProps: siteDetailEventMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: () => {
                return false;
            }
        },
        {
            type: "CONTENT",
            route: "content",
            showSideBar: false,
            showContentHeader: false,
            showFooter: true,
            showHeader: false,
            bannerName: undefined,
            pageTitle: undefined,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "CUSTOM_COMPONENT",
            route: "content",
            showSideBar: false,
            showContentHeader: false,
            showFooter: true,
            showHeader: false,
            bannerName: undefined,
            pageTitle: undefined,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        }
        /*{
            type: "SUMMARY",
            route: "findings",
            bannerName: undefined,
            showSideBar: true,
            showContentHeader: true,
            showFooter: false,
            sidebarLink: {
                label: "FINDINGS",
                icon: require("../assets/img/data.svg"),
                hiddenOnTabs: []
            },
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "ADMIN",
            route: "settings",
            bannerName: undefined,
            showSideBar: true,
            showContentHeader: true,
            showFooter: false,
            sidebarLink: {
                label: "SETTINGS",
                icon: require("../assets/img/cog.png"),
                hiddenOnTabs: []
            },
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        }, 
        {
            type: "USER_PROFILE",
            route: "user",
            bannerName: undefined,
            showSideBar: true,
            showContentHeader: true,
            showFooter: false,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "SITE_DETAIL",
            route: "site-detail",
            bannerName: undefined,
            showSideBar: true,
            showContentHeader: true,
            showFooter: false,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: siteDetailMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined;
            },
            shouldRerouteHome: siteDetailShouldRerouteHome
        },
        {
            type: "SITE_DETAIL_EVENT",
            route: "site-detail-event",
            bannerName: undefined,
            showSideBar: true,
            showContentHeader: true,
            showFooter: false,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: siteDetailEventMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: siteDetailEventShouldRerouteHome
        },*/

    ], // Order matters. First is the default

    totalsGraphTitle: "Scan Activity",
    summaryGraphTitle: "Summary",
    classificationL1: "Species",
    classificationL2: undefined,

    /* BANNER SETTINGS */
    showBannerLogin: true,
    showBannerLoginForm: false,
    showBannerLogout: true,
    showBannerProfile: true,

    /* FILTER SETTINGS */
    filterTitle: "Filter",
    defaultFilterDays: 7300, //moment().diff(GetSeasonalQuarterDate(GetSeasonalQuarterDate(moment())), 'days'),
    filterPrintShow: false,
    filterBackShow: true,
    filterDisableInterface: false,

    /* MAPPING SETTING */
    enableCreateNewSite: true,
    enableAnonymousCreation: false,
    defaultGraphColors: ['#A79350', '#79a750', '#a75079', '#7e50a7', '#FFC00F', '#E6A2A0', '#E4DBCF', '#CCCC00', '#D1E6B4', '#9A9663', '#7A7663'],

    defaultMapMarkerZoom: 10,
    defaultMapType: "normal",
    donutCharts: true,


    IsMarkerActive: (marker) => {
        return marker.endDate
            && moment(marker.endDate).isAfter(
                GetSeasonalQuarterDate(
                    GetSeasonalQuarterDate(moment())
                )
            );
    },
    /* Common function may be used across all products */
    GetSeasonalQuarterDate: GetSeasonalQuarterDate,

    GetSeasonName: GetSeasonName,

    aggregateData: (data: Datum[], keyField: string, valueField: string) => {
        let aggregate: Aggregate[] = data.map((datum) => {
            let keyAny = datum[keyField];
            let key = typeof keyAny == "string" ? keyAny : undefined;

            let valueAny = datum[valueField];
            let value = typeof valueAny == "number" ? valueAny : undefined;
            return {
                key: key,
                count: data
                    .filter(o => o[keyField] === key)
                    .length,
                value: data
                    .filter(o => o[keyField] === key)
                    .reduce(((sum, o) => value ? sum + value : sum), 0)
            };
        });

        //Above this number, round to two decimal places, otherwise only to one
        const precisionThreshold = 120;
        let reduced: Aggregate[] = aggregate.reduce(function (a: Aggregate[], d) {
            if (a.filter(o => o.key === d.key).length === 0) {
                d.mean = d.value ? d.count > precisionThreshold ? (d.value / d.count).toFixed(2) : (d.value / d.count).toFixed(1) : undefined;
                a.push(d);
            }
            return a;
        }, []);

        return reduced;
    },

    /* Map Sytles */
    mapStyles: [
        {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        /*{
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#444444"
                },
                {
                    "visibility": "on"
                }
            ]
        },*/
        {
            "featureType": "administrative",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#f2f2f2"
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -50
                },
                {
                    "lightness": 45
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#469bec"
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        }
    ] // go with the default map styles
}